import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import { postProduct } from "../../../api/product";
import { ROLES } from "../../../utils/constants";
import { alertError, alertSuccess } from "../../../utils/logger";

function getEmptyProduct() {
  return {
    referencia: "",
    descripcion: "",
    familia_id: null,
    marca_id: null,
    tipo_producto_id: null,
    precio: null,
    tipo_unidad_id: null,
    tiempo_instalacion: null,
    descuento_base: null,
  };
}

function simplifyProduct(input) {
  const safe = input || {};

  return {
    referencia: safe.referencia ?? "",
    descripcion: safe.descripcion ?? "",
    familia_id: safe.familia_id ?? safe.familia?.id ?? null,
    marca_id: safe.marca_id ?? safe.marca?.id ?? null,
    tipo_producto_id: safe.tipo_producto_id ?? safe.tipo_producto?.id ?? null,
    precio: safe.precio ?? null,
    tipo_unidad_id: safe.tipo_unidad_id ?? safe.tipo_unidad?.id ?? null,
    tiempo_instalacion: safe.tiempo_instalacion ?? null,
    descuento_base: safe.descuento_base ?? null,
  };
}

const DuplicarProductoDialog = (props) => {
  const { title, open, setOpen, data, onSave } = props;

  const [product, setProduct] = useState(getEmptyProduct());

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );
  const isOfferManager = loggedUser?.role?.rango === ROLES.GESTOR_OFERTAS;

  useEffect(() => {
    if (open && data) {
      setProduct({
        ...getEmptyProduct(),
        ...simplifyProduct(data),
      });
    }
  }, [open, data]);

  function saveProduct() {
    let error = "";

    if (!product?.descripcion) {
      error = "La descripción es obligatoria.";
    } else if (!product?.referencia) {
      error = "La referencia es obligatoria.";
    } else if (!product?.familia_id) {
      error = "La familia es obligatoria.";
    } else if (!product?.tipo_producto_id) {
      error = "El tipo de producto es obligatorio.";
    } else if (!product?.tipo_unidad_id) {
      error = "El tipo de unidad es obligatoria.";
    } else if (!isOfferManager && !product?.precio) {
      error = "El precio es obligatorio.";
    } else if (!product?.tiempo_instalacion) {
      error = "El tiempo de instalación es obligatorio.";
    }

    if (error) {
      alertError({ error });
      return;
    }

    postProduct(
      isOfferManager
        ? { ...product, precio: 0, descuento_base: 0 }
        : product,
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 201) {
          alertSuccess({
            title: "¡Guardado!",
            customMessage: "Producto duplicado con éxito.",
          });

          setOpen(false);
          setProduct(getEmptyProduct());

          if (typeof onSave === "function") onSave();
        }
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se ha podido duplicar el producto.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setProduct({ ...product, [element]: event.target.value });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="duplicar-producto-dialog"
      className="backdrop"
    >
      <DialogTitle id="duplicar-producto-dialog">{title}</DialogTitle>

      <DialogContent>
        <CardBody className="pt-0 px-0">
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <TextField
                fullWidth
                label="Referencia"
                value={product.referencia || ""}
                onChange={handleChange("referencia")}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>

            <div className="col-md-6">
              <TextField
                fullWidth
                label="Descripción"
                value={product.descripcion || ""}
                onChange={handleChange("descripcion")}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>
        </CardBody>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
            setProduct(getEmptyProduct());
          }}
          color="secondary"
          variant="outlined"
        >
          Cancelar
        </Button>

        <Button onClick={saveProduct} color="primary" variant="outlined">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicarProductoDialog;
